var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g2, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g3, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g4, _path65, _path66, _path67, _path68, _g5, _path69, _path70, _g6, _path71, _path72, _path73, _g7, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _g8, _path83, _path84, _g9, _path85, _path86;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233,
    height: 114,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFD",
    d: "M130.013 3.182c-10.108 2.604-21.027 9.533-29.984 14.954a64.97 64.97 0 0 1-46.772 7.787C20.394 17.87-10.033 53.566 3.168 84.662l7.932 20.477h219.555c11.793-62.704-35.524-119.34-100.642-101.957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FE",
    d: "M100.814 42.945H78.592v62.193h22.222z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEDBFA",
    d: "M111.926 42.945h-11.112v62.193h11.112z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFD",
    d: "M83.619 46.906h-2.226v7.28h2.226zM88.416 46.906h-2.227v7.28h2.227zM93.216 46.906H90.99v7.28h2.226zM98.017 46.906h-2.226v7.28h2.226zM83.619 56.232h-2.226v7.28h2.226zM88.416 56.232h-2.227v7.28h2.227zM93.216 56.232H90.99v7.28h2.226zM98.017 56.232h-2.226v7.28h2.226zM83.619 65.576h-2.226v7.28h2.226zM88.416 65.576h-2.227v7.28h2.227zM93.216 65.576H90.99v7.28h2.226zM98.017 65.576h-2.226v7.28h2.226zM83.619 74.92h-2.226v7.28h2.226zM88.416 74.92h-2.227v7.28h2.227zM93.216 74.92H90.99v7.28h2.226zM98.017 74.92h-2.226v7.28h2.226zM83.619 84.265h-2.226v7.279h2.226zM88.416 84.265h-2.227v7.279h2.227zM93.216 84.265H90.99v7.279h2.226zM98.017 84.265h-2.226v7.279h2.226z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FE",
    d: "M97.793 34.355H86.682v8.591h11.111z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEDBFA",
    d: "M102.658 34.355h-4.865v8.591h4.865z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M94.095 23.966h-.878v10.388h.878z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFD",
    d: "M86.682 42.945a183 183 0 0 1 15.974 0c-5.297.235-10.678.233-15.974 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FE",
    d: "M30.857 63.225H15.633v41.914h15.224z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEDBFA",
    d: "M40.846 63.225h-9.99v41.914h9.99z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFD",
    d: "M20.446 66.369H17.7v2.742h2.747zM24.618 66.369h-2.747v2.742h2.747zM28.788 66.369h-2.747v2.742h2.747zM20.446 70.334H17.7v2.742h2.747zM24.618 70.334h-2.747v2.742h2.747zM28.788 70.334h-2.747v2.742h2.747zM20.446 74.297H17.7v2.743h2.747zM24.618 74.297h-2.747v2.743h2.747zM28.788 74.297h-2.747v2.743h2.747zM20.446 78.262H17.7v2.743h2.747zM24.618 78.262h-2.747v2.743h2.747zM28.788 78.262h-2.747v2.743h2.747zM20.446 82.227H17.7v2.743h2.747zM24.618 82.227h-2.747v2.743h2.747zM28.788 82.227h-2.747v2.743h2.747zM20.446 86.192H17.7v2.743h2.747zM24.618 86.192h-2.747v2.743h2.747zM28.788 86.192h-2.747v2.743h2.747z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FE",
    d: "M57.438 52.148H37.404v52.991h20.034z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEDBFA",
    d: "M67.904 52.148H57.438v52.722h10.466z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFD",
    d: "M54.788 55.404h-14.73v2.285h14.73zM54.788 59.071h-14.73v2.285h14.73zM54.788 62.738h-14.73v2.285h14.73zM54.788 66.404h-14.73v2.285h14.73zM54.788 70.07h-14.73v2.285h14.73zM54.788 73.738h-14.73v2.285h14.73zM66.731 55.404H58.72v2.285h8.012zM66.731 59.071H58.72v2.285h8.012zM66.731 62.738H58.72v2.285h8.012zM66.731 66.404H58.72v2.285h8.012zM66.731 70.07H58.72v2.285h8.012zM66.731 73.738H58.72v2.285h8.012z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FE",
    d: "M137.087 52.148h-20.034v52.991h20.034z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEDBFA",
    d: "M147.555 52.148h-10.467v52.991h10.467z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFD",
    d: "M134.434 55.404h-14.729v2.285h14.729zM134.434 59.071h-14.729v2.285h14.729zM134.434 62.738h-14.729v2.285h14.729zM134.434 66.404h-14.729v2.285h14.729zM134.434 70.07h-14.729v2.285h14.729zM134.434 73.738h-14.729v2.285h14.729zM146.38 55.404h-8.013v2.285h8.013zM146.38 59.071h-8.013v2.285h8.013zM146.38 62.738h-8.013v2.285h8.013zM146.38 66.404h-8.013v2.285h8.013zM146.38 70.07h-8.013v2.285h8.013zM146.38 73.738h-8.013v2.285h8.013z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FE",
    d: "M135.596 33.975h-13.621v18.173h13.621z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEDBFA",
    d: "M141.519 33.975h-5.921v18.173h5.921z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FE",
    d: "M133.469 22.867h-8.326v11.108h8.326z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEDBFA",
    d: "M137.088 22.867h-3.619v11.108h3.619z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFD",
    d: "M121.975 52.148a273 273 0 0 1 19.543 0 274 274 0 0 1-19.543 0M125.143 33.975c3.978-.234 7.967-.234 11.945 0-3.978.232-7.967.232-11.945 0M133.931 35.988h-10.29v2.148h10.29zM133.931 39.273h-10.29v2.147h10.29zM133.931 42.557h-10.29v2.148h10.29zM133.931 45.841h-10.29v2.148h10.29zM140.642 35.988h-3.871v2.148h3.871zM140.642 39.273h-3.871v2.147h3.871zM140.642 42.557h-3.871v2.148h3.871zM140.642 45.841h-3.871v2.148h3.871z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M130.4 13.601h-.386v9.265h.386z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FE",
    d: "M179.331 49.112h-25.12v56.375h25.12z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEDBFA",
    d: "M193.12 49.112h-13.788v56.375h13.788zM163.533 52.903h-5.775v4.261h5.775zM176.203 52.903h-5.775v4.261h5.775zM163.533 59.326h-5.775v4.26h5.775zM176.203 59.326h-5.775v4.26h5.775zM163.533 65.747h-5.775v4.26h5.775zM176.203 65.747h-5.775v4.26h5.775zM163.533 72.169h-5.775v4.26h5.775zM176.203 72.169h-5.775v4.26h5.775zM163.533 78.59h-5.775v4.262h5.775zM176.203 78.59h-5.775v4.262h5.775zM163.533 85.013h-5.775v4.26h5.775zM176.203 85.013h-5.775v4.26h5.775z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "M3.266 112.534c75.473-.753 152.062-.761 227.535 0-75.472.761-152.062.753-227.535 0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#571FA7",
    d: "M9.26 104.874h98.691c6.183.283 6.982-9.079 8.908-13.134 0 0-5.381-10.454-35.742-12.501-29.427-23.121-51.97-3.641-73.122 6.984a1.62 1.62 0 0 0-.894 1.248l-1.647 12.733c-.325 1.065 2.066 3.209 2.492 4.021a1.67 1.67 0 0 0 1.314.649"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 112,
    height: 37,
    x: 5,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.26 104.874h98.691c6.183.283 6.982-9.078 8.908-13.134 0 0-5.381-10.453-35.742-12.5-29.427-23.122-51.97-3.642-73.122 6.984a1.62 1.62 0 0 0-.894 1.248l-1.647 12.733c-.325 1.065 2.066 3.209 2.492 4.02a1.66 1.66 0 0 0 1.314.649"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3E0292",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.857 96.95H2.289v8.711h114.568z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.808 89.68c16.777.285 16.775 25.201 0 25.485-16.777-.286-16.774-25.202 0-25.485M46.473 102.849c-.286 16.75-25.242 16.748-25.526 0 .286-16.75 25.243-16.748 25.526 0"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "M33.691 91.294c-7.1-.03-12.458 6.604-10.946 13.58 5.318.015 16.523.048 21.877.032 1.612-6.856-3.86-13.703-10.93-13.612"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M43.782 102.43c-.227 13.251-19.97 13.249-20.194 0 .226-13.25 19.97-13.249 20.194 0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "M33.684 108.021c-7.36-.131-7.36-11.052 0-11.183 7.36.132 7.36 11.053 0 11.183"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M37.578 101.843h-1.146a.492.492 0 0 1-.347-.838c.248-.341 1.358-.995.81-1.503-.714-.922-1.185.133-1.735.58a.49.49 0 0 1-.535.106.49.49 0 0 1-.304-.453c-.06-.42.25-1.653-.491-1.635-.353-.038-.823.044-.816.491v1.144a.492.492 0 0 1-.84.347c-.342-.247-.997-1.355-1.505-.81-.277.222-.55.613-.229.924l.81.809a.492.492 0 0 1-.348.838h-1.145c-.684-.018-.684 1.324 0 1.305h1.145a.492.492 0 0 1 .348.838l-.81.809c-.318.309-.051.705.229.924.512.541 1.162-.556 1.505-.81a.5.5 0 0 1 .536-.106.49.49 0 0 1 .304.453v1.144c-.007.443.463.535.816.491.741.015.427-1.207.492-1.635a.49.49 0 0 1 .303-.453.496.496 0 0 1 .536.106l.81.81c.479.491 1.416-.446.924-.924l-.81-.809a.49.49 0 0 1 .074-.755.5.5 0 0 1 .273-.083h1.146c.685.017.683-1.324 0-1.305"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "M35.681 102.43c-.045 2.619-3.947 2.619-3.991 0 .044-2.619 3.947-2.619 3.991 0M94.81 91.252c-7.07-.091-12.542 6.756-10.934 13.611h21.863c1.613-6.857-3.858-13.702-10.928-13.611"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M104.907 102.453c-.227 13.251-19.97 13.249-20.194 0 .226-13.25 19.968-13.249 20.194 0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "M94.811 108.045c-7.36-.132-7.36-11.052 0-11.184 7.36.132 7.359 11.053 0 11.184"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M98.706 101.866H97.56a.492.492 0 0 1-.347-.839c.246-.341 1.357-.995.81-1.502-.714-.922-1.185.133-1.735.58a.5.5 0 0 1-.536.106.49.49 0 0 1-.303-.454c-.061-.42.249-1.652-.492-1.634-.352-.039-.822.044-.816.49v1.144a.494.494 0 0 1-.84.348c-.34-.248-.996-1.356-1.504-.81-.277.222-.551.613-.23.924l.81.808a.5.5 0 0 1 .106.535.49.49 0 0 1-.454.304h-1.145c-.684-.018-.684 1.323 0 1.305h1.145a.492.492 0 0 1 .348.838l-.81.808c-.318.308-.05.705.23.924.512.542 1.162-.556 1.505-.809a.49.49 0 0 1 .755.075.5.5 0 0 1 .084.272v1.143c-.006.443.464.535.816.492.742.014.428-1.208.492-1.635a.493.493 0 0 1 .84-.347l.81.809c.477.491 1.415-.446.923-.924l-.81-.808a.492.492 0 0 1 .075-.755.5.5 0 0 1 .273-.083h1.146c.684.018.682-1.327 0-1.305"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "M96.808 102.454c-.044 2.619-3.947 2.619-3.992 0 .046-2.62 3.948-2.62 3.992 0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "M77.88 79.499a2921 2921 0 0 1-2.776 23.965l-.014.123c-5.467.013-16.183.02-21.649 0v-.141l.006-3.655.032.085c-1.476-1.766-4.41-5.288-5.883-7.053.558-3.688 1.235-8.076 1.815-11.762-.498 3.683-1.102 8.068-1.623 11.748l-.02-.074c1.493 1.755 4.46 5.247 5.95 7.004l.007 3.705-.142-.141c5.328-.019 16.06-.012 21.382 0l-.14.123c.948-7.706 2.038-16.216 3.055-23.93z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "M53.208 86.139c-1.09-.086-3.528.49-3.349-1.35h4.57c-.014.695-.473 1.362-1.22 1.35M28.306 77.464l3.737 3.444h-8.912s2.759-2.08 5.175-3.444"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "m29.29 76.887 4.425 3.993 15.697.187 1.452-10.522c-6.435.177-13.734 1.894-21.575 6.342"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M77.883 79.5s-10.74-9.403-27.02-8.956L49.41 81.066l25.443.303z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 29,
    height: 12,
    x: 49,
    y: 70,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.883 79.498s-10.74-9.402-27.02-8.955L49.41 81.065l25.443.303z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "m59.64 70.544-2.31 10.057h2.942l3.081-9.579z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "m49.67 79.186 25.183 2.183-25.443-.302z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "M74.303 83.508h-2.985c-3.218-.055-3.219-4.834 0-4.889h2.985c3.218.058 3.218 4.838 0 4.889M110.86 89.387l6.001 2.357-1.367 3.825s-4.626-1.443-5.354-5.6a.54.54 0 0 1 .189-.502.53.53 0 0 1 .531-.08M6.77 90.05h4.927a.624.624 0 0 1 .5.991c-.252.18-3.268 4.838-3.665 4.528H6.055zM116.857 69.807l-1.559-3.459a1.02 1.02 0 0 0-.972-.597c-10.431-.085-28.11 9.154-33.451 13.149l.48.682c4.27-3.983 28.872-14.983 33.179-12.72.481.593 1.312 3.075 2.323 2.945"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1949",
    d: "M142.025 48.945s-.302.304-.636 1.03c0 0 .571-.437 1.281-.408a2.4 2.4 0 0 0-.645-.622"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M101.964 49.078c-.293-11.158-17.071-10.037-15.877 1.054h-.068s1.407 9.116 7.976 14.66c0 0 7.004-5.97 7.905-14.66q.067-.526.064-1.054"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.11 47.796c-.07 4.093-6.17 4.093-6.235 0 .067-4.094 6.165-4.093 6.236 0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "M213.588 33.795h-40.605a2.817 2.817 0 0 0-2.819 2.814v73.111a2.817 2.817 0 0 0 2.819 2.814h40.605a2.817 2.817 0 0 0 2.819-2.814V36.61a2.817 2.817 0 0 0-2.819-2.815"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#F1F8FE",
    d: "M212.842 41.344h-39.108v64.775h39.108z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 40,
    height: 66,
    x: 173,
    y: 41,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M212.84 41.344h-39.108v64.775h39.108z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFD",
    d: "M212.837 41.344h-21.749v23.672h21.749z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M207.088 91.524V80.909h5.894v-2.755h-5.894V67.54h5.75v-2.755H201.92V40.843h-2.211v23.942h-8.622V41.344h-4.002v23.441h-13.354v2.755h13.356v10.614h-13.209v2.755h13.209v10.615H173.59l.037 2.754h13.455v11.841h4.005v-11.84h22.043v-2.755zM191.087 67.54h13.431v10.614h-13.431zm0 23.984V80.909h13.431v10.615z"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M200.699 71.113c-.097-3.681-5.632-3.311-5.238.348h-.023s.463 3.007 2.631 4.835c0 0 2.311-1.97 2.607-4.835q.023-.174.023-.348"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M199.099 70.69c-.006 1.343-2.05 1.343-2.058 0s2.052-1.34 2.058 0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M183.124 85.23c-.067-2.558-3.917-2.302-3.643.243h-.016s.323 2.091 1.83 3.364c0 0 1.607-1.37 1.813-3.364q.016-.12.016-.242"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M182.012 84.937c.014.927-1.445.927-1.432 0-.013-.927 1.446-.927 1.432 0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M204.555 98.859c-.068-2.559-3.918-2.303-3.643.242h-.017s.322 2.091 1.83 3.364c0 0 1.608-1.371 1.814-3.364q.016-.12.016-.242"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M203.442 98.567c.012.927-1.446.927-1.432 0-.014-.927 1.445-.927 1.432 0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFD",
    d: "M187.09 67.605h-13.356v10.55h13.356zM204.448 80.911h-13.356v10.552h13.356zM187.088 94.28h-13.424v11.839h13.424z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "M217.503 55.7h-35.89a4.57 4.57 0 0 1-3.231-1.337 4.555 4.555 0 0 1 0-6.452 4.57 4.57 0 0 1 3.231-1.337h35.89c5.997.1 6.016 9.023 0 9.126"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M181.628 54.056c-2.606.064-4.005-3.307-2.116-5.101 1.111-1.16 3.119-1.16 4.233 0 1.892 1.778.471 5.18-2.117 5.101m0-5.48c-3.293.084-3.291 4.904 0 4.984 3.281-.055 3.281-4.93 0-4.985"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m184.243 52.968-.712.711.469.468.712-.71z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#692CBF",
    d: "m142.934 58.147 6.641 4.076-3.699 4.632z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA19D",
    d: "M142.289 52.653c-.21 1.17.838 1.349 1.025.17.213-1.167-.831-1.346-1.025-.17M137.38 52.653c.209 1.17-.839 1.349-1.025.17-.213-1.167.833-1.346 1.025-.17M138.323 53.658h3.026c-.365 1.04.427 6.249.427 6.249h-3.887s.8-5.21.434-6.25"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D2C6",
    d: "M136.915 52.8c.072 4.664 5.765 4.663 5.837 0 .517-4.771-6.201-4.82-5.837 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 7,
    height: 8,
    x: 136,
    y: 49,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M136.915 52.8c.072 4.664 5.765 4.663 5.837 0 .517-4.771-6.201-4.82-5.837 0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDA19D",
    d: "M141.934 50.17s-1.76 1.706-4.596.44l4.221-1.15z"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#59445A",
    d: "M142.714 51.891s-1.381-.82-1.324-1.917c0 0-1.662.805-4.051.637 0 0-.363.938-.382 1.279 0 0-.737-1.3-.452-2.482.283-1.433 6.132-2.838 5.522-.465 1.2.764 1.041 1.885.687 2.948"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "M135.429 112.534c-.079-.875 1.271-1.126 1.838-1.43l1.159-.831.059-.995 2.015-.447.901 2.978-3.261.725-.009-.013z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "m146.792 72.593-.705 36.838h-2.481l-5.202-36.921z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 9,
    height: 38,
    x: 138,
    y: 72,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m146.792 72.593-.705 36.838h-2.481l-5.202-36.921z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A437D",
    d: "M139.801 82.404c3.606 4.782 4.692 20.639 4.976 27.527H142.6l-2.692-16.877z"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "m141.162 72.51-2.982 21.658h-.026l2.557 14.778-2.477.785-4.163-12.266c-1.537-3.369-.98-21.025-1.296-24.876z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 10,
    height: 38,
    x: 132,
    y: 72,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m141.164 72.51-2.982 21.658h-.026l2.557 14.778-2.477.785-4.163-12.266c-1.537-3.369-.98-21.025-1.296-24.876z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A437D",
    d: "M139.802 82.404c-5.609 15.036-3.835 12.417-.012 27.027l1.954-.597-2.382-15.434.44-11.002"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "m145.673 109.434.274.958 2.958 1.265a.96.96 0 0 1 .581.88h-6.109l.231-3.103z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "M133.984 62.605c.558-3.704 3.39-5.56 6.565-5.15 2.522 0 4.682 2.167 5.135 5.15l2.07 13.645h-15.84z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 17,
    height: 20,
    x: 131,
    y: 57,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M133.982 62.606c.558-3.704 3.39-5.561 6.565-5.15 2.522 0 4.682 2.167 5.135 5.15l2.07 13.645h-15.84z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "M141.16 62.738c5.374 7.398 4.485 5.476 5.875 14.447l1.488-.222-1.488-10.948z"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "m146.267 66.365-1.111-5.59s1.335 3.087 2.392 4.029z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A437D",
    d: "M146.724 76.253h-13.949l.123 2.42 13.728 2.707z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDA19D",
    d: "m148.785 63.21 2.754 2.597-2.599 2.18-2.672-1.625z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#692CBF",
    d: "m138.213 57.455-8.102 1.28.572 5.314 5.237-.482z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#324D90",
    d: "M137.749 64.687h2.87c.3 0 .543-.243.543-.542V58.94c0-.3-.243-.543-.543-.543h-2.87c-.3 0-.544.243-.544.542v5.205c0 .3.244.542.544.542"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D2C6",
    d: "M137.614 61.876c1.668-.05 2.065-.212 3.551-.905v-.831l.961 1.142 8.921 4.185c1.408.614 1.462 2.75.075 3.425a1.95 1.95 0 0 1-2.2-.064l-7.505-5.466c-.494.112-1.298.41-1.806.332-.153-.05-1.392-.034-1.453-.235l-.74-1.209a.24.24 0 0 1-.035-.12.26.26 0 0 1 .028-.122.25.25 0 0 1 .084-.092.25.25 0 0 1 .119-.04"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "m133.81 63.762.536-2.985s-1.614 1.914-1.655 3.092z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D2C6",
    d: "m130.199 59.562-3.095.718c-.202-.12-10.009 4.605-10.426 4.743l1.407 1.685c2.01-.52 10.628-3.06 12.557-3.035z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    width: 15,
    height: 8,
    x: 116,
    y: 59,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m130.199 59.563-3.095.718c-.202-.12-10.009 4.605-10.426 4.742l1.407 1.686c2.01-.52 10.628-3.06 12.557-3.036z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDA19D",
    d: "M131.177 61.839c-2.423.646-10.313 3.854-12.525 4.723 2.689-.647 9.932-2.388 12.552-2.842z"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D2C6",
    d: "M117.564 64.612c-2.408-.297-2.922.198-4.955 1.265 1.794.648 2.367.698 4.249.396l.267.748c-.043.416-.443 1.098-.131 1.476a.24.24 0 0 0 .19.094.24.24 0 0 0 .106-.025.24.24 0 0 0 .083-.07c.337-.431 1.002-1.29 1.031-1.364.038-.095.248-.938.248-.938z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    width: 7,
    height: 5,
    x: 112,
    y: 64,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117.566 64.612c-2.408-.297-2.922.198-4.955 1.265 1.794.648 2.367.698 4.249.396l.267.748c-.043.416-.443 1.098-.131 1.476a.24.24 0 0 0 .19.094.24.24 0 0 0 .106-.025.24.24 0 0 0 .083-.07c.337-.431 1.002-1.29 1.031-1.364.038-.095.248-.938.248-.938z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDA19D",
    d: "m114.729 66.46 2.326-.663.256 1.213-.373.81.086-.885-.256-.53s-1.527.366-2.038.055"
  }))), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#152E60",
    d: "M97.638 79.09a144 144 0 0 1-8.519-10.661c2.996 3.4 5.862 6.988 8.519 10.66M101.492 77.335c.309-4.324.839-8.686 1.578-12.963-.308 4.325-.84 8.686-1.578 12.963M103.904 81.066a132 132 0 0 1 12.461-3.954 132 132 0 0 1-12.461 3.954M103.07 79.021a76 76 0 0 1 7.039-7.027 76 76 0 0 1-7.041 7.025zM99.781 78.344a76 76 0 0 1-2.877-9.515 76 76 0 0 1 2.877 9.515"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.697 53.447v-5.09h1.72q.596 0 .979.203.383.202.567.554.184.354.184.803t-.184.798a1.3 1.3 0 0 1-.564.547q-.381.197-.972.197h-1.392v-.557h1.372q.407 0 .656-.12a.76.76 0 0 0 .363-.338q.114-.22.114-.527 0-.305-.114-.534a.78.78 0 0 0-.365-.353q-.252-.127-.664-.127h-1.084v4.544zm2.396-2.287 1.253 2.287h-.716l-1.233-2.287zm3.561 2.367q-.552 0-.952-.244a1.64 1.64 0 0 1-.614-.686 2.35 2.35 0 0 1-.213-1.029q0-.587.213-1.034.217-.45.602-.701.387-.255.905-.254.298 0 .589.1.29.1.529.323.239.22.381.587.141.365.141.9v.248h-2.943v-.507h2.347q0-.323-.13-.577a.97.97 0 0 0-.914-.547q-.35 0-.607.174a1.14 1.14 0 0 0-.39.448 1.3 1.3 0 0 0-.137.591v.338q0 .433.149.734.152.298.42.455.268.154.624.154.232 0 .418-.065a.9.9 0 0 0 .326-.199q.136-.134.211-.333l.567.16q-.09.288-.301.506a1.5 1.5 0 0 1-.522.338q-.31.12-.699.12m5.079 1.352v-2.018h-.05q-.064.104-.184.263a1.1 1.1 0 0 1-.34.281q-.222.122-.589.122-.478 0-.843-.241a1.63 1.63 0 0 1-.572-.686q-.206-.446-.206-1.052 0-.6.206-1.044.207-.443.574-.683.369-.242.85-.242.373 0 .59.125.218.121.333.278.117.154.181.254h.07v-.607h.567v5.25zM197.649 53a.97.97 0 0 0 .597-.183 1.15 1.15 0 0 0 .37-.515q.127-.33.127-.763 0-.427-.124-.748a1.1 1.1 0 0 0-.368-.502.98.98 0 0 0-.602-.182 1 1 0 0 0-.621.192 1.15 1.15 0 0 0-.371.514 2 2 0 0 0-.122.726q0 .408.125.74.126.331.373.528a.97.97 0 0 0 .616.194m5.151-1.113V49.63h.586v3.818h-.586v-.646h-.04q-.135.291-.418.495-.283.201-.716.201-.357 0-.636-.157a1.1 1.1 0 0 1-.438-.477q-.159-.32-.159-.808V49.63h.587v2.386q0 .418.234.667a.8.8 0 0 0 .601.248 1 1 0 0 0 .445-.112.97.97 0 0 0 .383-.343q.157-.23.157-.589m3.262 1.64q-.552 0-.952-.243a1.63 1.63 0 0 1-.614-.686 2.3 2.3 0 0 1-.214-1.029q0-.587.214-1.034.216-.45.601-.701.388-.255.905-.254.298 0 .589.1.29.1.53.323.238.22.38.587.141.365.142.9v.248h-2.944v-.507h2.347q0-.323-.129-.577a1 1 0 0 0-.363-.4 1 1 0 0 0-.552-.147q-.35 0-.607.174a1.14 1.14 0 0 0-.39.448 1.3 1.3 0 0 0-.137.591v.338q0 .433.15.734.151.298.42.455.268.154.624.154.231 0 .417-.065a.9.9 0 0 0 .326-.199q.136-.134.211-.333l.567.16q-.09.288-.301.506a1.5 1.5 0 0 1-.522.338q-.31.12-.698.12m5.178-3.042-.527.15a1 1 0 0 0-.147-.257.7.7 0 0 0-.259-.209.94.94 0 0 0-.42-.081q-.35 0-.584.161-.231.159-.231.405 0 .219.159.346.16.127.497.211l.567.14q.512.123.763.38a.9.9 0 0 1 .251.653.97.97 0 0 1-.189.587 1.25 1.25 0 0 1-.522.408q-.336.15-.78.149-.585 0-.967-.254a1.12 1.12 0 0 1-.485-.74l.557-.14q.08.309.301.463.223.153.584.154.41 0 .651-.174.244-.177.244-.423a.44.44 0 0 0-.14-.333q-.139-.136-.427-.204l-.637-.149q-.524-.124-.77-.385a.93.93 0 0 1-.244-.659q0-.323.182-.572.184-.248.499-.39.319-.142.721-.142.567 0 .89.249.325.248.463.656m2.613-.855v.497h-1.979v-.497zm-1.402-.915h.586v3.64q0 .248.072.372.075.123.189.164.117.04.246.04.097 0 .16-.01l.099-.02.119.527q-.059.023-.166.045a1.2 1.2 0 0 1-.271.025q-.249 0-.487-.107a.96.96 0 0 1-.393-.325.93.93 0 0 1-.154-.552z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenOrder);
export default __webpack_public_path__ + "static/media/openOrder.2654331fc84a7791fa6e1c8aa7ab16c8.svg";
export { ForwardRef as ReactComponent };